import get from 'lodash/get';

import { optimizePath } from '../../helpers/optimize-path';
import { wallpaperFormat } from '../../helpers/wallpaper-format';

import request from '@module/http/axios/request';
import { userHasPlusTier } from '@app/helper/user';

export const PlusProvider = {
  get name() {
    return 'PLUS_PROVIDER';
  },

  isRotationEnabled() {
    return true;
  },

  rotationInterval(config) {
    return config.defaultRotationInterval;
  },

  // Show editorial wallpapers when:
  // - or we are on a channel but no user wallpapers are available,
  // - or we are not in a channel, and there is a logged in plus user with no wallpapers set
  test(config, { channel, user }) {
    const isLoggedInPlusUser = user.loggedIn && userHasPlusTier(user);

    return (
      (channel.name || isLoggedInPlusUser) &&
      config.channelWallpapers.length === 0
    );
  },

  async nextCreative(config) {
    const response = await request({
      path: config.editorialUrl,
      params: {
        utm_source: 'desktop',
        utm_reason: 'plus',
      },
    });

    return this.parseResponse(config, response.body);
  },

  parseResponse(config, response) {
    const src = response.src;

    return {
      src: optimizePath({ src: `${config.host}${src}` }),
      format: wallpaperFormat(src),
      meta: {
        href: get(response, 'meta.href', ''),
        title: get(response, 'meta.title', ''),
      },
    };
  },
};
